import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { getOrganizationAppVersion } from '@core/constants/appVersion';
import useOrganizationSettings from '@core/hooks/useOrganizationSettings';
import useSnackbar from '@core/hooks/useSnackbar';
import isCustomErroHandlerResponse from '@core/utils/isCustomErrorHandlerResponse';
import VIEWER_VERSION_NOTIFICATION_MESSAGES from '../../constants/viewerVersionNotificationMessages';
import useSetViewerVersionSetting from '../../hooks/useSetViewerVersionSetting';

const ViewerVersion = () => {
  const showSnackbar = useSnackbar();
  const { organizationSettings, isSuccess } = useOrganizationSettings();
  const { isSaving, setViewerVersionAsync } = useSetViewerVersionSetting();
  const isNewViewerEnabled = getOrganizationAppVersion(organizationSettings) === 'v3';

  const handleChange = async (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const { SAVE_SUCCESS, SAVE_ERROR } = VIEWER_VERSION_NOTIFICATION_MESSAGES;
    try {
      const result = await setViewerVersionAsync(checked ? 'v3' : 'v2');
      if (isCustomErroHandlerResponse(result)) {
        showSnackbar({ ...SAVE_ERROR, type: 'error' });
        return;
      }
      showSnackbar({ ...SAVE_SUCCESS, type: 'success' });
    } catch {
      showSnackbar({ ...SAVE_ERROR, type: 'error' });
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={isNewViewerEnabled}
          disabled={!isSuccess || isSaving}
          onChange={handleChange}
        />
      }
      label="Usar el nuevo visor para los usuarios de la organización."
    />
  );
};

export default ViewerVersion;
